import React from 'react';
import { Select2 } from '@economic/taco';

import { Field } from '~/app/shared/components/Form';

interface Props {
    name: string;
    label: string;
    options: { label: string; value: string | number }[];
    required?: boolean;
}

const Select2FormField = ({ name, label, options, ...props }: Props) => {
    return (
        <Field as={Select2} name={name} aria-label={label} label={label} {...props}>
            {options.map(data => (
                <Select2.Option key={data.label} value={data.value}>
                    {data.label}
                </Select2.Option>
            ))}
        </Field>
    );
};

export default Select2FormField;
